//
//
//
//
//
//
//
//
//
//


export default {
	name: 'tabbox',
	props: {
        showTitle: {
            default: false,
            type: Boolean,
        },
        tabData: {
            default: (res)=>{
                return []
            },
        }
    },
    data(){
        return {
            default: 0,
        }
    },
    methods: {
        change(item,index){

            this.tabData.forEach(res=>{
                res.active = '';
            })
            this.tabData[index].active = true;
            this.$emit("on-change",item,index);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/tabbox.vue